import React from "react";
import Moment from "react-moment";

type Props = { product: any };

const BasicInformation = ({ product }: Props) => {
  const koboAmount = (amount: string) =>
    (+amount / 100).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

  return (
    <div className="grid gap-x-6 grid-cols-4">
      <span>
        <label htmlFor="unitPrice" className="mt-[30px] text-grey">
          Unit Price
        </label>
        <input
          name="unitPrice"
          type="text"
          value={koboAmount(product?.data?.unitPrice)}
          disabled
          className="px-6 py-4 bg-[#F7F7F7] mt-[13px] mb-[25px] w-full border-[1px] ease-in-out duration-300 border-[#D3D3D3] focus:border-orange rounded-md"
        />
      </span>
      <span>
        <label htmlFor="bulkPrice" className="mt-[30px] text-grey">
          Bulk Price
        </label>
        <input
          name="bulkPrice"
          type="text"
          value={koboAmount(product?.data?.bulkPrice)}
          disabled
          className="px-6 py-4 bg-[#F7F7F7] mt-[13px] mb-[25px] w-full border-[1px] ease-in-out duration-300 border-[#D3D3D3] focus:border-orange rounded-md"
        />
      </span>
      <span>
        <label htmlFor="unitWeight" className="mt-[30px] text-grey">
          Unit Weight
        </label>
        <input
          name="unitWeight"
          type="text"
          value={product?.data?.unitWeight}
          disabled
          className="px-6 py-4 bg-[#F7F7F7] mt-[13px] mb-[25px] w-full border-[1px] ease-in-out duration-300 border-[#D3D3D3] focus:border-orange rounded-md"
        />
      </span>
      <span>
        <label htmlFor="bulkWeight" className="mt-[30px] text-grey">
          Bulk Weight
        </label>
        <input
          name="bulkWeight"
          type="text"
          value={product?.data?.bulkWeight}
          disabled
          className="px-6 py-4 bg-[#F7F7F7] mt-[13px] mb-[25px] w-full border-[1px] ease-in-out duration-300 border-[#D3D3D3] focus:border-orange rounded-md"
        />
      </span>
      <span>
        <label htmlFor="unitTotalStock" className="mt-[30px] text-grey">
          Unit Total Stock
        </label>
        <input
          name="unitTotalStock"
          type="text"
          value={product?.data?.unitTotalStock}
          disabled
          className="px-6 py-4 bg-[#F7F7F7] mt-[13px] mb-[25px] w-full border-[1px] ease-in-out duration-300 border-[#D3D3D3] focus:border-orange rounded-md"
        />
      </span>
      <span>
        <label htmlFor="bulkTotalStock" className="mt-[30px] text-grey">
          Bulk Total Stock
        </label>
        <input
          name="bulkTotalStock"
          type="text"
          value={product?.data?.bulkTotalStock}
          disabled
          className="px-6 py-4 bg-[#F7F7F7] mt-[13px] mb-[25px] w-full border-[1px] ease-in-out duration-300 border-[#D3D3D3] focus:border-orange rounded-md"
        />
      </span>
      <span>
        <label htmlFor="unitStockMeasurement" className="mt-[30px] text-grey">
          Unit Stock Measurement
        </label>
        <input
          name="unitStockMeasurement"
          type="text"
          value={product?.data?.unitStockMeasurement}
          disabled
          className="px-6 py-4 bg-[#F7F7F7] mt-[13px] mb-[25px] w-full border-[1px] ease-in-out duration-300 border-[#D3D3D3] focus:border-orange rounded-md"
        />
      </span>
      <span>
        <label htmlFor="bulkStockMeasurement" className="mt-[30px] text-grey">
          Bulk Stock Measurement
        </label>
        <input
          name="bulkStockMeasurement"
          type="text"
          value={product?.data?.bulkStockMeasurement}
          disabled
          className="px-6 py-4 bg-[#F7F7F7] mt-[13px] mb-[25px] w-full border-[1px] ease-in-out duration-300 border-[#D3D3D3] focus:border-orange rounded-md"
        />
      </span>
      <span>
        <label
          htmlFor="bulkShippingMinQtyBetty"
          className="mt-[30px] text-grey"
        >
          Bulk Shipping Min. Betty
        </label>
        <input
          name="bulkShippingMinQtyBetty"
          type="text"
          value={product?.data?.bulkShippingMinQtyBetty}
          disabled
          className="px-6 py-4 bg-[#F7F7F7] mt-[13px] mb-[25px] w-full border-[1px] ease-in-out duration-300 border-[#D3D3D3] focus:border-orange rounded-md"
        />
      </span>
      <span>
        <label
          htmlFor="bulkShippingMaxQtyBetty"
          className="mt-[30px] text-grey"
        >
          Bulk Shipping Max. Betty
        </label>
        <input
          name="bulkShippingMaxQtyBetty"
          type="text"
          value={product?.data?.bulkShippingMaxQtyBetty}
          disabled
          className="px-6 py-4 bg-[#F7F7F7] mt-[13px] mb-[25px] w-full border-[1px] ease-in-out duration-300 border-[#D3D3D3] focus:border-orange rounded-md"
        />
      </span>
      <span>
        <label htmlFor="bulkShippingMinQtyUber" className="mt-[30px] text-grey">
          Bulk Shipping Min. Uber
        </label>
        <input
          name="bulkShippingMinQtyUber"
          type="text"
          value={product?.data?.bulkShippingMinQtyUber}
          disabled
          className="px-6 py-4 bg-[#F7F7F7] mt-[13px] mb-[25px] w-full border-[1px] ease-in-out duration-300 border-[#D3D3D3] focus:border-orange rounded-md"
        />
      </span>
      <span>
        <label htmlFor="bulkShippingMaxQtyUber" className="mt-[30px] text-grey">
          Bulk Shipping Max. Uber
        </label>
        <input
          name="bulkShippingMaxQtyUber"
          type="text"
          value={product?.data?.bulkShippingMaxQtyUber}
          disabled
          className="px-6 py-4 bg-[#F7F7F7] mt-[13px] mb-[25px] w-full border-[1px] ease-in-out duration-300 border-[#D3D3D3] focus:border-orange rounded-md"
        />
      </span>
      <span>
        <label
          htmlFor="bulkShippingMinQtyWalkIn"
          className="mt-[30px] text-grey"
        >
          Bulk Shipping Min. Qty. WalkIn
        </label>
        <input
          name="bulkShippingMinQtyWalkIn"
          type="text"
          value={product?.data?.bulkShippingMinQtyWalkIn}
          disabled
          className="px-6 py-4 bg-[#F7F7F7] mt-[13px] mb-[25px] w-full border-[1px] ease-in-out duration-300 border-[#D3D3D3] focus:border-orange rounded-md"
        />
      </span>
      <span>
        <label htmlFor="lowBulkStock" className="mt-[30px] text-grey">
          Low Bulk Stock
        </label>
        <input
          name="lowBulkStock"
          type="text"
          value={product?.data?.lowBulkStock}
          disabled
          className="px-6 py-4 bg-[#F7F7F7] mt-[13px] mb-[25px] w-full border-[1px] ease-in-out duration-300 border-[#D3D3D3] focus:border-orange rounded-md"
        />
      </span>
      <span>
        <label htmlFor="lowUnitStock" className="mt-[30px] text-grey">
          Low Unit Stock
        </label>
        <input
          name="lowUnitStock"
          type="text"
          value={product?.data?.lowUnitStock}
          disabled
          className="px-6 py-4 bg-[#F7F7F7] mt-[13px] mb-[25px] w-full border-[1px] ease-in-out duration-300 border-[#D3D3D3] focus:border-orange rounded-md"
        />
      </span>
      <span>
        <label htmlFor="createdAt" className="mt-[30px] text-grey">
          Date Added
        </label>
        <span className="block px-6 py-4 bg-[#F7F7F7] mt-[13px] mb-[25px] w-full border-[1px] ease-in-out duration-300 border-[#D3D3D3] focus:border-orange rounded-md">
          <Moment interval={0} format="DD-MM-YYYY hh:mm a">
            {product?.data?.createdAt}
          </Moment>
        </span>
      </span>
    </div>
  );
};

export default BasicInformation;
